import DataLoader from "dataloader"
import { useQuery } from "@tanstack/react-query"
import { get } from "../typed-client/get"

const loader = new DataLoader(
  async (keys: readonly number[]) => {
    const results = await get("/api/ActivityType/GetActivityTypes", {
      ids: [...keys],
    })
    return keys.map((key) => results?.find((x) => x.activityTypeId === key))
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedActivityType(key?: number) {
  return useQuery({
    queryKey: ["ActivityType", key],
    queryFn: () => loader.load(key!),
    enabled: key !== undefined,
  })
}
